import * as React from 'react'
import { cn } from '~/lib/utils'

// 미니멀 멀티라인 입력 — Input과 동일 보더/포커스, 세로 리사이즈.
// maxLength가 있으면 우하단에 작은 muted 글자수 카운터를 표시한다.
export type TextareaProps = React.ComponentProps<'textarea'> & {
    error?: boolean
}

function Textarea({
    className,
    error,
    ref,
    maxLength,
    value,
    defaultValue,
    onChange,
    ...props
}: TextareaProps) {
    const showCount = typeof maxLength === 'number'
    const initial = String(value ?? defaultValue ?? '').length
    const [count, setCount] = React.useState(initial)
    // 제어형이면 value 기준, 비제어형이면 onChange로 추적.
    const current = value != null ? String(value).length : count

    const textarea = (
        <textarea
            ref={ref}
            data-slot='textarea'
            aria-invalid={error || undefined}
            className={cn(
                'border-input bg-card text-foreground placeholder:text-muted-foreground focus:border-primary focus:ring-ring/20 disabled:bg-muted min-h-20 w-full resize-y rounded-[var(--radius)] border px-2.5 py-2 text-[13px] transition-colors focus:ring-2 focus:outline-none disabled:opacity-50',
                error &&
                    'border-destructive focus:border-destructive focus:ring-destructive/20',
                className
            )}
            maxLength={maxLength}
            value={value}
            defaultValue={defaultValue}
            onChange={(e) => {
                if (showCount) setCount(e.target.value.length)
                onChange?.(e)
            }}
            {...props}
        />
    )

    if (!showCount) return textarea

    return (
        <div className='relative'>
            {textarea}
            <div className='text-muted-foreground pointer-events-none absolute right-2.5 bottom-2 text-[11px]'>
                <span>{current}</span>
                <span aria-hidden='true'>/</span>
                <span>{maxLength}</span>
                <span className='sr-only'>자 입력</span>
            </div>
        </div>
    )
}

export { Textarea }
